import React from 'react';
import PropTypes from 'prop-types';
import { TableHead } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  TableCellHeaderStickyTop,
  TableCellHeaderStickyTopAndLeft,
  TableCellStyledWithHeaderTextValueSmall
} from 'components/list/TableComponentsStyled';
import { RoundedHeaderTableRow } from 'components/common/table/TableStyles';

const RefineAuthorizationListResponsiveTableHead = ({ userGroups }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <RoundedHeaderTableRow>
        <TableCellHeaderStickyTopAndLeft>{`${t('Authorization.DocumentType')} - ${t(
          'Authorization.State'
        )}`}</TableCellHeaderStickyTopAndLeft>
        <TableCellHeaderStickyTop />
        {userGroups?.map(item => {
          return <TableCellStyledWithHeaderTextValueSmall key={item.id}>{item.name}</TableCellStyledWithHeaderTextValueSmall>;
        })}
      </RoundedHeaderTableRow>
    </TableHead>
  );
};
RefineAuthorizationListResponsiveTableHead.propTypes = {
  userGroups: PropTypes.array.isRequired
};

export default RefineAuthorizationListResponsiveTableHead;
